import React, { useState, useEffect } from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';
import { SESSION_CONFIG } from '../config/sessionConfig';

const SessionTimeoutModal = ({ show, onExtend, onLogout }) => {
    const [remainingTime, setRemainingTime] = useState(SESSION_CONFIG.WARNING_DURATION / 1000);
    useEffect(() => {
        if (show) {
            // Reset timer whenever modal opens
            setRemainingTime(SESSION_CONFIG.WARNING_DURATION / 1000);
        }
    }, [show]);
    useEffect(() => {
        if (!show) return;

        const interval = setInterval(() => {
            setRemainingTime(prev => {
                if (prev <= 1) {
                    onLogout();
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, [show, onLogout]);

    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins}:${secs.toString().padStart(2, '0')}`;
    };

    return (
        <Modal show={show} backdrop="static" keyboard={false} centered>
            <Modal.Header>
                <Modal.Title>Session Timeout Warning</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Alert variant="warning">
                    Your session will expire in {formatTime(remainingTime)} due to inactivity.
                    Would you like to continue your session?
                </Alert>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onLogout}>
                    Logout
                </Button>
                <Button variant="primary" onClick={onExtend}>
                    Continue Session
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default SessionTimeoutModal;
